import { render } from "./CreateSickLeaveComponent.vue?vue&type=template&id=77e0c1e7"
import script from "./CreateSickLeaveComponent.vue?vue&type=script&lang=js"
export * from "./CreateSickLeaveComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jellevanoosterbosch/PhpstormProjects/haaer/haaer-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__